// extracted by mini-css-extract-plugin
export default {"loaderContainer":"loader_loaderContainer__8xub0","loader":"loader_loader__M-FUL","rotate":"loader_rotate__PZK3t","prixClipFix":"loader_prixClipFix__jAAqm"};